import React from "react";
import { connect } from "react-redux";

import BootstrapTable from "react-bootstrap-table-next";
import Loader from "../../Loader/Loader.js";
import {
  MetricTable,
  sortNumeric,
  ComponentWithUrl,
} from "./../../Utils/Utils.js";

function title(cell, row) {
  return (
    <span className="table-content-cell">
      <span className="table-content-cell__media">
        <img
          src={row.thumbnail}
          alt={row.title}
          className="table-content-cell__img"
        />
      </span>
      <span className="table-content-cell__link">{row.title}</span>
    </span>
  );
}

function table_cell_number(cell, row) {
  return <MetricTable {...cell} format={"number"} />;
}

function table_cell_time(cell, row) {
  return <MetricTable {...cell} format={"time"} />;
}

class ContentFacebookVideoViews extends ComponentWithUrl {
  renderTable() {
    const { loading, data } = this.props;

    if (loading) {
      return <Loader minHeight={650} col={"col-12"} />;
    }

    // add unique ids
    data.data.forEach((d, i) => (d.id = i));

    const columns = [
      {
        dataField: "title",
        text: "Title",
        style: { width: "220px", minWidth: "220px", textAlign: "left" },
        headerAlign: "left",
        formatter: title,
        sort: true,
      },
      {
        dataField: "views",
        text: "Views",
        style: { width: "175px", minWidth: "175px" },
        formatter: table_cell_number,
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "avg_time_watched",
        text: "Avg View Time",
        style: { width: "175px", minWidth: "175px" },
        formatter: table_cell_time,
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "paid_views",
        text: "Paid",
        style: { width: "175px", minWidth: "175px" },
        formatter: table_cell_number,
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "likes",
        text: "Likes",
        style: { width: "175px", minWidth: "175px" },
        formatter: table_cell_number,
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "comments",
        text: "Comments",
        style: { width: "175px", minWidth: "175px" },
        formatter: table_cell_number,
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    const defaultSorted = [
      {
        dataField: "views",
        order: "desc",
      },
    ];

    return (
      <BootstrapTable
        keyField="id"
        data={data.data}
        columns={columns}
        defaultSorted={defaultSorted}
        striped={false}
        hover={false}
        bordered={false}
      />
    );
  }

  render() {
    return <div>{this.renderTable()}</div>;
  }
}

const mapStateToProps = (state, props) => {
  const myState = state.data[props.url];
  return {
    data: myState ? myState.data : null,
    loading: myState ? myState.loading : true,
  };
};

export default connect(mapStateToProps)(ContentFacebookVideoViews);
